import { observer } from 'mobx-react'
import * as React from 'react'
import { FieldNo } from '../../atoms/FieldNo'
import { HideTablet } from '../../atoms/HideTablet'
import { IntakeStepCol } from '../../atoms/IntakeStepCol'
import { IntakeStepContainer } from '../../atoms/IntakeStepContainer'
import { IntakeStepNoColTablet } from '../../atoms/IntakeStepNoColTablet'
import { Label } from '../../atoms/Label'
import { RadioButton } from '../../atoms/RadioButton'
import {
  GetOwnIntakeQuery_getOwnIntake, UpdateOwnIntakeMutationVariables,
} from '../../schema/schemaTypes'

interface IProps {
  id: string
  active: boolean
  handleSubmit: (vars: UpdateOwnIntakeMutationVariables) => void
  intake: GetOwnIntakeQuery_getOwnIntake
  isCompleted: boolean
  label: string | JSX.Element
  name: string
  no: number
  options?: Array<{ value: any, label: string }>
}

export const IntakeStepRadioButtons = observer(
  ({ active, handleSubmit, intake, id, isCompleted, label, name, no, options }: IProps) => (
    <IntakeStepContainer id={id} active={active}>
      <IntakeStepNoColTablet>
        <FieldNo checked={isCompleted}>{no}</FieldNo>
      </IntakeStepNoColTablet>
      <IntakeStepCol>
        <Label><HideTablet><FieldNo checked={isCompleted}>{no}</FieldNo></HideTablet>{label}</Label>
        {(options || []).map(o => (
          <RadioButton disabled={!active}
            // tslint:disable-next-line:jsx-no-lambda
            onChange={(e: React.ChangeEvent<HTMLInputElement>) => handleSubmit({ [name]: o.value })}
            id={`intake-${id}-options-${o.value}`} name={`intake-${id}-options`} label={o.label}
            checked={intake[name] === o.value} key={o.value}
          />
        ))}
        {/* <FieldError /> */}
      </IntakeStepCol>
    </IntakeStepContainer>
  ))



// WEBPACK FOOTER //
// ./src/organisms/Intakes/IntakeStepRadioButtons.tsx